import React from "react";
import GooglePlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from "react-google-places-autocomplete";
import { GoogleAPI } from "../../utils/keys";

interface LocationInputProps {
  value?: any;
  setValue?: (value: any) => void;
  setCenter?: (value: { latitude: number; longitude: number }) => void;
  onSelectLocation?: (location: {
    address: string | undefined;
    latitude: number;
    longitude: number;
    country?: string;
    city?: string;
  }) => void;
  placeholder?: string;
  height?: number;
}

const ProtocolLocationInput = ({
  value,
  setValue,
  setCenter,
  onSelectLocation,
  placeholder,
  height,
}: LocationInputProps) => {
    const handleChange = (suggestion: any) => {
        setValue && setValue(suggestion);
      
        geocodeByAddress(suggestion.label)
          .then((results) => {
            const addressComponents = results[0].address_components;
            const country = addressComponents.find((comp) =>
              comp.types.includes("country")
            )?.long_name;
            const city = addressComponents.find((comp) =>
              comp.types.includes("locality") || comp.types.includes("administrative_area_level_1")
            )?.long_name;
      
            return Promise.all([getLatLng(results[0]), { country, city }]);
          })
          .then(([location, { country, city }]) => {
            setCenter &&
              setCenter({
                latitude: location.lat,
                longitude: location.lng,
              });
      
            onSelectLocation &&
              onSelectLocation({
                address: city?.trim(), 
                latitude: location.lat,
                longitude: location.lng,
                country,
                city,
              });
          });
      };
      

  return (
    <div>
      <GooglePlacesAutocomplete
        apiKey={GoogleAPI}
        selectProps={{
          value,
          onChange: handleChange,
          placeholder,
          styles: {
            input: (provided) => ({
              ...provided,
              height: height || 40,
            }),
          },
        }}
      />
    </div>
  );
};

export default ProtocolLocationInput;
